import React, { MouseEventHandler } from "react";

import { Tag } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { QuoteStatus, QuoteStatusesLabel } from "@assets/constants";

type StatusTagsProps = {
  /** Handle the click on the tags. */
  onClick?: MouseEventHandler;
  /** The active status key. */
  activeStatus?: string;
};

const StatusTags = ({ onClick, activeStatus }: StatusTagsProps) => {
  const { t } = useTranslation();
  const statuses = Object.keys(QuoteStatus);
  const isActive = (status: QuoteStatus) => status === activeStatus;
  return (
    <>
      {statuses.map((status: QuoteStatus) => (
        <Tag
          color={isActive(status) ? "primary" : "neutral-200"}
          key={status}
          onClick={onClick}
          value={status}
        >
          {t(QuoteStatusesLabel[status])}
        </Tag>
      ))}
    </>
  );
};

export default StatusTags;
